import { createRouter,createWebHistory } from 'vue-router'
// import { getStorage,setStorage  } from '../utils/auth.js'
import Index from '../pages/index/index'
import Index2 from '../pages/no-auth/index';
import { onceExecute } from '../utils/utils'
import { getAccessToken } from '@/request'
import { injectConfig } from '@/utils/wxsdk.js'
const routes = [
    { path: '/', component: Index },
    { path: '/video-watch', component: Index },
    { path: '/video-watch2', component: Index2 }
]

// const notLogin = ['/share-staff','/register-success','/register-agreement','/app-code','/pre-view','/pre-view-video','/pre-view-pdf'];
export const router = createRouter({
    history: createWebHistory(),
    routes,
})
router.beforeEach(async (to,from,next) => {
    await onceExecute(async () => {
        const config = await getAccessToken({ url: location.href.split('#')[0] })
        injectConfig({
            timestamp: config.timestamp, // 生成签名的时间戳
            nonceStr: config.noncestr, // 生成签名的随机串
            signature: config.sign, // 签名
        })
    })
    // }
    next()
})

